import {
    Avatar,
    AvatarBadge,
    Box,
    Flex,
    ListItem,
    Spacer,
    Stack,
    Text,
    Tooltip
} from "@chakra-ui/react";
import React from "react";
import { Call, ParticipantRole } from "../../graphql";
import { formatDate, getFullName } from "../../utils";

type ICallItemProps = {
  call: Call;
};

const WaitingCallItem: React.FC<ICallItemProps> = ({ call }) => {
    const caller = call.participants.find(
        (p) => p.role === ParticipantRole.Caller
    );

    const callerFullName = getFullName(caller.account);

    return (
        <ListItem bg="white" borderRadius="md" padding={ 2 }>
            <Box>
                <Flex>
                    <Box w="60px" h="18">
                        <Tooltip label={ callerFullName } aria-label={ callerFullName }>
                            <Avatar name={ callerFullName } src={ caller.account.email }></Avatar>
                        </Tooltip>
                    </Box>
                    <Box h="18">
                        <Text fontWeight={ 500 }>{ callerFullName }</Text>
                        <Text as="small">{ formatDate(call.requestTime) }</Text>
                    </Box>
                </Flex>
            </Box>
        </ListItem>
    );
};

export default WaitingCallItem;
